import TIcon from './icon.vue'

TIcon.install = Vue => {
  Vue.component(TIcon.name, TIcon)
}

export default TIcon



// WEBPACK FOOTER //
// ./src/module/icon/index.js